export enum CompensationMethod {
  REFUND = "refund",
  STORE_CREDIT = "store_credit",
  EXCHANGE = "exchange",
}

export const compensationMethodToTitle: Record<CompensationMethod, string> = {
  [CompensationMethod.REFUND]: "Refund",
  [CompensationMethod.STORE_CREDIT]: "Store credit",
  [CompensationMethod.EXCHANGE]: "Exchange",
};
